import { render } from "./UserRank.vue?vue&type=template&id=689baccb"
import script from "./UserRank.vue?vue&type=script&lang=js"
export * from "./UserRank.vue?vue&type=script&lang=js"

import "./UserRank.vue?vue&type=style&index=0&id=689baccb&lang=css"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__